// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import PasswordRevealController from "./password_reveal_controller"
application.register("password-reveal", PasswordRevealController)

import RoleExclusivityController from "./role_exclusivity_controller"
application.register("role-exclusivity", RoleExclusivityController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import IconPickerController from "./icon_picker_controller"
application.register("icon-picker", IconPickerController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import Sortable from "@stimulus-components/sortable"
application.register("sortable", Sortable)

import NestedSortableController from "./nested_sortable_controller"
application.register("nested-sortable", NestedSortableController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)
